/**
 * Scroll Reveal + Animations — Bobble Buddy Theme
 * - Intersection Observer for entrance animations
 * - Parallax depth on sections
 * - Animated number counters
 */

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ─── Scroll Reveal ─── */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-reveal], [data-stagger]').forEach(function (el) {
    revealObserver.observe(el);
  });

  // Auto-tag section headers
  document.querySelectorAll('.section-header').forEach(function (el) {
    if (!el.hasAttribute('data-reveal') && !el.hasAttribute('data-stagger')) {
      el.setAttribute('data-reveal', '');
      revealObserver.observe(el);
    }
  });

  /* ─── Animated Number Counter ─── */
  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('.stats-counter__number').forEach(function (el) {
    counterObserver.observe(el);
  });

  function animateCounter(el) {
    var text = el.textContent.trim();
    var match = text.match(/^([+]?)([0-9,]+)([+%]?)$/);
    if (!match) return; // Non-numeric like "5 ⭐", skip

    var prefix = match[1];
    var numStr = match[2].replace(/,/g, '');
    var suffix = match[3];
    var target = parseInt(numStr, 10);
    if (isNaN(target)) return;

    var duration = 1800;
    var start = performance.now();
    var hasComma = match[2].includes(',');

    el.textContent = prefix + '0' + suffix;

    function step(now) {
      var progress = Math.min((now - start) / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);

      var display = hasComma ? current.toLocaleString() : String(current);
      el.textContent = prefix + display + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  /* ─── Parallax on Scroll ─── */
  var parallaxElements = document.querySelectorAll('.hero, .cta-banner');

  if (parallaxElements.length > 0) {
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.scrollY;
          parallaxElements.forEach(function (el) {
            var rect = el.getBoundingClientRect();
            var center = rect.top + rect.height / 2;
            var viewCenter = window.innerHeight / 2;
            var offset = (center - viewCenter) * 0.08;

            // Only apply when element is near viewport
            if (rect.bottom > 0 && rect.top < window.innerHeight) {
              el.style.backgroundPositionY = offset + 'px';
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ─── Smooth Hover Tilt for Cards ─── */
  document.querySelectorAll('.how-it-works__card, .testimonials__card').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var centerX = rect.width / 2;
      var centerY = rect.height / 2;
      var rotateX = (y - centerY) / centerY * -4;
      var rotateY = (x - centerX) / centerX * 4;

      card.style.transform = 'perspective(600px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-6px)';
    });

    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });

  /* ─── Reveal Fallback ───
   * Safety net: if IntersectionObserver misses any element (iOS Safari quirks,
   * slow load, CDN/JS failures), force-reveal everything 800ms after full page load
   * so critical product info never stays invisible.
   */
  function forceRevealAll() {
    document.querySelectorAll('[data-reveal]:not(.is-revealed), [data-stagger]:not(.is-revealed)').forEach(function (el) {
      el.classList.add('is-revealed');
    });
  }
  if (document.readyState === 'complete') {
    setTimeout(forceRevealAll, 800);
  } else {
    window.addEventListener('load', function () { setTimeout(forceRevealAll, 800); });
  }
})();
